// Small shared presentation helpers
export const money = (value: number) => `$${Math.round(value).toLocaleString()}`;

export const percent = (value: number, digits = 1) => `${value.toFixed(digits)}%`;

export const initialsOf = (name: string) => {
  const letters = name.replace(/[^A-Za-z]/g, '');
  return (letters.slice(0, 2) || '??').toUpperCase();
};